<template>
  <div class="legend">
    <section class="legend__section">
      <h3 class="legend__subtitle">Calendar Colors</h3>
      <ul class="legend-list">
        <li class="legend-list__item">
          <span class="legend-color legend-color--inhouse"></span>
          <span class="legend-list__label">In-House</span>
        </li>
        <li class="legend-list__item">
          <span class="legend-color legend-color--checkedout"></span>
          <span class="legend-list__label">Checked-Out</span>
        </li>
        <li class="legend-list__item">
          <span class="legend-color legend-color--confirmed"></span>
          <span class="legend-list__label">Confirmed</span>
        </li>
        <li class="legend-list__item">
          <span class="legend-color legend-color--provisional"></span>
          <span class="legend-list__label">Provisional</span>
        </li>
        <li class="legend-list__item">
          <span class="legend-color legend-color--vacant"></span>
          <span class="legend-list__label">Bed in Twin (Vacant)</span>
        </li>
        <li class="legend-list__item">
          <span class="legend-color legend-color--shared"></span>
          <span class="legend-list__label">Bed in Twin (Shared)</span>
        </li>
        <li class="legend-list__item">
          <span class="legend-color legend-color--unavailable"></span>
          <span class="legend-list__label">Unavailable</span>
        </li>
        <li class="legend-list__item">
          <span class="legend-color legend-color--block"></span>
          <span class="legend-list__label">Block</span>
        </li>
      </ul>
    </section>
    <section class="legend__section">
      <h3 class="legend__subtitle">Icons</h3>
      <ul class="legend-icons">
        <li class="legend-icons__item">
          <span class="legend-icons__glyph">
            <LockerIcon/>
          </span>
          <span class="legend-icons__label">Locked Assignment</span>
        </li>
        <li class="legend-icons__item">
          <span class="legend-icons__glyph legend-icons__glyph--dot"></span>
          <span class="legend-icons__label">Outstanding Balance</span>
        </li>
      </ul>
    </section>
    <section class="legend__section">
      <h3 class="legend__subtitle">Calendar Header</h3>
      <div class="legend-header__example">
        <div class="legend-card">
          <div class="legend-card__month">AUG 2025</div>
          <div class="legend-card__body">
            <div class="legend-card__dow">SAT</div>
            <div class="legend-card__day">19</div>
            <div class="legend-card__occ">83,87%</div>
          </div>
          <div class="legend-card__footer">
            <span class="legend-card__avail">1</span>
          </div>
          <div class="legend-line legend-line--month">
            <span class="legend-line__label">Month &amp; Year</span>
          </div>
          <div class="legend-line legend-line--date">
            <span class="legend-line__label">Date</span>
          </div>
          <div class="legend-line legend-line--occupancy">
            <span class="legend-line__label">Occupancy</span>
          </div>
          <div class="legend-line legend-line--available">
            <span class="legend-line__label">Available Rooms</span>
          </div>
        </div>
        <div class="legend-card legend-card--highlight">
          <div class="legend-card__month">AUG 2025</div>
          <div class="legend-card__body">
            <div class="legend-card__dow">SAT</div>
            <div class="legend-card__day">19</div>
            <div class="legend-card__qty">2</div>
            <div class="legend-card__occ">83,87%</div>
          </div>
          <div class="legend-card__footer">
            <span class="legend-card__avail legend-card__avail--zero">0</span>
          </div>
          <div class="legend-line legend-card--qty">
            <span class="legend-line__label">QTY</span>
          </div>
          <div class="legend-line legend-card--unassigned">
            <span class="legend-line__label">Unassigned Rooms<br> on this date</span>
          </div>
          <div class="legend-line legend-card--no-rooms">
            <span class="legend-line__label">No Rooms<br> Available</span>
          </div>
        </div>
      </div>
    </section>
    <section class="legend__section">
      <h3 class="legend__subtitle">Scrolling the Calendar</h3>
      <p class="legend__text">
        To scroll the calendar, click and drag it horizontally.<br>
        You can also navigate with your keyboard using the arrow keys in any direction.
      </p>
    </section>
  </div>
</template>

<script>
import LockerIcon from '@/views/hotel-management/calendar/icons/LockerIcon.vue'

export default {
  name: 'HCLegend',
  components: { LockerIcon },
}
</script>

<style scoped>
.legend {
  color: #303030;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.legend__section {
  padding: 16px 0;
  border-top: 1px solid #eee;
}

.legend__section:first-of-type {
  border-top: 0;
  padding-top: 8px;
}

.legend__subtitle {
  margin-bottom: 16px;
  color: #666;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.52px;
  text-transform: uppercase;
}

.legend__text {
  color: #303030;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.legend-list {
  display: grid;
  grid-template-columns:repeat(2, minmax(240px, 1fr));
  gap: 10px 20px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.legend-list__item {
  display: flex;
  align-items: center;
  gap: 14px;
}

.legend-list__label {
  color: #303030;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.legend-color {
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 6px;
}

.legend-color--inhouse {
  background-color: #96c96c;
}

.legend-color--checkedout {
  background-color: #b6b6b6;
}

.legend-color--confirmed {
  background-color: #8dcee7;
}

.legend-color--provisional {
  background-color: #69afb5;
}

.legend-color--vacant {
  background-color: #ecb533;
}

.legend-color--shared {
  background-color: #50a7d3;
}

.legend-color--unavailable {
  background-color: #eb602d;
}

.legend-color--block {
  background-color: #52524d;
}

.legend-icons {
  display: grid;
  grid-template-columns:repeat(2, minmax(240px, 1fr));
  gap: 10px 20px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.legend-icons__item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legend-icons__label {
  color: #303030;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.legend-icons__glyph--dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff6a00;
}

.legend-header__example {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.legend-card {
  position: relative;
  width: 100px;
  border: 1px solid #e6e6e6;
  background-color: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .03);
}

.legend-card--highlight .legend-line:before {
  background-color: #ffb65f;
}

.legend-card--highlight .legend-card__body {
  background: linear-gradient(180deg, #ffcc85 0%, #ffc67b 100%);
}

.legend-card__month {
  padding: 12px 8px;
  border-bottom: 1px solid #e6e6e6;
  background-color: #f9f9f9;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  text-transform: uppercase;
  text-align: center;
}

.legend-card__body {
  position: relative;
  padding: 12px 8px;
  text-align: center;
}

.legend-card__dow {
  font-size: 11px;
  font-weight: 500;
  color: #5f5f5f;
  font-family: 'MazzardSoftH', sans-serif;
}

.legend-card__day {
  margin-top: 2px;
  color: #181818;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 17px;
  font-weight: 600;
}

.legend-card__occ {
  margin-top: 6px;
  color: #181818;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
}

.legend-card__footer {
  border-top: 1px solid #e6e6e6;
  padding: 10px 0;
  background-color: #f9f9f9;
  text-align: center;
}

.legend-card__avail {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  border-radius: 3px;
  color: #181818;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 12px;
  line-height: 18px;
}

.legend-card__qty {
  position: absolute;
  right: 8px;
  top: 8px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 50%;
  background-color: #ff8400;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
}

.legend-card__avail--zero {
  background-color: #eb602d;
  color: #fff;
}

.legend-line {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-line:before {
  content: '';
  display: inline-block;
  width: 33px;
  height: 1px;
  background-color: #e6e6e6;
}

.legend-line--month {
  top: 11px;
  right: -121px;
}

.legend-line--date {
  top: 60px;
  right: -63px;
}

.legend-line--occupancy {
  top: 90px;
  right: -108px;
}

.legend-line--available {
  top: 130px;
  right: -140px;
}

.legend-card--qty {
  top: 50px;
  right: -61px;
}

.legend-card--unassigned {
  top: 73px;
  right: -160px;
}

.legend-card--no-rooms {
  top: 124px;
  right: -100px;
}

.legend-line__label {
  color: #303030;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

</style>
